import { Wrench,  ClipboardCheck, Gauge, FileText, Users, History, Cog, SearchCheck, RefreshCcwDot } from 'lucide-react';
import { Link } from 'react-router-dom';
import portImage from '../assets/images/port.jpg';
import Hero from '../components/sections/Hero';
import styles from '../styles/pages/Home.module.css';

const Home = () => {
  return (
    <div className={styles.container}>
      <Hero
        title="Spécialiste en moteurs diesel industriels"
        subtitle="Expertise en diagnostic, réparation et maintenance de moteurs diesel"
        backgroundImage={portImage}
      />

      <div className={styles.homeContainer}>
        
        {/* Section 1: Présentation de l'activité */}
        <section className={styles.presentation} id="presentation">
          <div className={styles.presentationHeader}>
            <h2 className={styles.presentationTitle}>
              Votre Expert en Moteurs Diesel Industriels
            </h2>
            <div className={styles.divider} />
            <p className={styles.presentationText}>
              <strong>MECA-GTECH</strong> est spécialisée dans la <strong>maintenance, 
                la réparation et le dépannage de moteurs diesel industriels</strong>.
                Nous intervenons sur site ou en atelier pour garantir le bon fonctionnement de vos équipements, 
                réduire vos arrêts de production et prolonger la durée de vie vos machines.
            </p>
          </div>

          <div className={styles.featuresGrid}>
            {[
              {
                icon: <Gauge size={40} />,
                title: 'Performance',
                desc: 'Intervention rapide sur site pour la réparation et le diagnostic des moteurs diesel industriels'
              },
              {
                icon: <ClipboardCheck size={40} />,
                title: 'Fiabilité',
                desc: 'Garantie du respect des normes de sécurité, de qualité et de traçabilité'
              },
              {
                icon: <Users size={40} />,
                title: 'Expertise',
                desc: 'Une équipe de techniciens qualifiés et expérimentés à votre service (+ de 20 ans d\'expérience)'
              }
            ].map((item, idx) => (
              <div key={idx} className={styles.featureCard}>
                <div className={styles.featureIcon}>
                  {item.icon}
                </div>
                <h3 className={styles.featureTitle}>
                  {item.title}
                </h3>
                <p className={styles.featureDesc}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Section 2: Les 5 Services Couverts */}
        <section className={styles.services} id="services">
          <div className={styles.servicesContainer}>
            <div className={styles.servicesHeader}>
              <h2 className={styles.servicesTitle}>
                Nos Services
              </h2>
              <div className={styles.dividerWhite} />
            </div>

            <div className={styles.servicesGrid}>
              {[
                {
                  icon: <ClipboardCheck size={48} />,
                  title: 'Diagnostic Technique',
                  desc: 'Enquête technique sur les symptômes et identifier rapidement les problèmes.',
                  link: '/services#diagnostic-technique'
                },
                {
                  icon: <SearchCheck size={48} />,
                  title: 'Expertise',
                  desc: 'Bilans de l\'état de vos composants internes et externes.',
                  link: '/services#expertise'
                },
                {
                  icon: <Wrench size={48} />,
                  title: 'Réparation',
                  desc: 'Restaurer les performances d\'origine : moteur complet, injecteurs, turbo, joints, pompes, etc...',
                  link: '/services#reparation'
                },
                {
                  icon: <RefreshCcwDot size={48} />,
                  title: 'Révision complète & Reconditionnement',
                  desc: 'Offrir les mêmes garanties fonctionnelles que l\'origine, réduire les coûts et les délais.',
                  link: '/services#revision-complete-reconditionnement'
                },
                {
                  icon: <Cog size={48} />,
                  title: 'Maintenance Industrielle',
                  desc: 'Suivi et entretien préventif de vos moteurs diesel pour les engins de chantier, groupes électrogènes et machines industrielles.',
                  link: '/services#maintenance-industrielle'
                },
                {
                  icon: <FileText size={48} />,
                  title: 'Contrats d\'entretien',
                  desc: 'Assurer la continuité de service, réduire les coûts de maintenance et maximiser la durée de vie de vos moteurs.',
                  link: '/services#contrats-entretien'
                }
              ].map((service, index) => (
                <Link to={service.link} key={index} className={styles.serviceCard} style={{ textDecoration: 'none' }}>
                  <div className={styles.serviceIcon}>
                    {service.icon}
                  </div>
                  <h3 className={styles.serviceTitle}>{service.title}</h3>
                  <p className={styles.serviceDesc}>{service.desc}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Section 3: À Propos */}
        <section className={styles.about} id="a-propos">
          <div className={styles.aboutHeader}>
            <h2 className={styles.aboutTitle}>
              À Propos de MECA-GTECH
            </h2>
            <div className={styles.divider} />
          </div>

          <div className={styles.aboutGrid}>
            {/* Histoire */}
            <div className={styles.aboutCard}>
              <div className={styles.aboutCardHeader}>
                <History size={36} className={styles.aboutIcon} />
                <h3 className={styles.aboutCardTitle}>
                  Notre Histoire
                </h3>
              </div>
              <p className={styles.history} style={{ padding: '0.5rem 4vw' }}>
                <strong>Une passion pour la mécanique, un engagement pour la performance industrielle.</strong>
      
                <p className={styles.history}>
                    Fondée en 2025 par 2 frères,
                MECA-GTECH est née d'une volonté claire: offrir aux professionels un service de maintenance et de réparation mécanique <strong>fiable,
                réactif</strong> et <strong>spécialisé</strong> dans les moteurs diesel industriels.
                </p>

                Notre entreprise intervient <strong>partout dans le monde</strong>, avec une capacité d'intervention rapide et un <strong>niveau d'exigeance constant</strong>.
                
              </p>
            </div>

            {/* Équipe */}
            {/* <div className="home-about-card team">
              <div className="home-about-card-header">
                <Users size={36} className="home-about-icon" />
                <h3 className="home-about-card-title">
                  Notre Équipe
                </h3>
              </div>
              <p className="home-about-text">
                Une équipe de techniciens hautement qualifiés et certifiés, 
                formés aux dernières technologies et normes du secteur.
              </p>
              <p className="home-about-text">
                Chaque membre apporte son expertise pour garantir un service 
                de qualité supérieure et un accompagnement personnalisé.
              </p>
            </div> */}

            {/* Moyens Techniques */}
            {/* <div className="home-about-card tech">
              <div className="home-about-card-header">
                <Cog size={36} className="home-about-icon" />
                <h3 className="home-about-card-title">
                  Moyens Techniques
                </h3>
              </div>
              <p className="home-about-text">
                Atelier équipé d'outils de diagnostic de pointe et de matériel 
                professionnel pour intervenir sur tous types de moteurs diesel.
              </p>
              <p className="home-about-text">
                Investissement constant dans les technologies modernes pour 
                garantir précision, efficacité et respect des délais.
              </p>
            </div> */}
          </div>
        </section>

      </div>
    </div>
  );
};

export default Home;